import { Map, List } from 'immutable';
import { CLOSE_SNACKBAR, CREATE_NOTIFICATION, OPEN_SNACKBAR, RESUME_SNACKBAR } from './constants';

export const initialState = Map({
	isSnackbarOpen: false,
	isSnackbarDelayed: false,
	messages: List(),
});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case CLOSE_SNACKBAR: {
			const messages = state.get('messages');
			return state.merge({
				// remove first message, delay if more messages exist
				isSnackbarOpen: false,
				isSnackbarDelayed: messages.count() > 1,
				messages: messages.count() === 1 ? messages.shift() : messages,
			});
		}
		case CREATE_NOTIFICATION:
			return state.merge({
				// add to end
				messages: state
					.get('messages')
					.push({ message: action.message, autoHideDuration: action.autoHideDuration }),
			});
		case OPEN_SNACKBAR:
			return state.merge({
				// open if there are messages and it isn't being delayed
				isSnackbarOpen: state.get('messages').count() > 0 && !state.get('isSnackbarDelayed'),
			});
		case RESUME_SNACKBAR:
			return state.merge({
				isSnackbarDelayed: false,
				messages: state.get('messages').shift(),
			});
		default:
			return state;
	}
};

export default reducer;
